<script>
import _ from 'lodash'

export default {
  props: {
    cart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchSuccess: !_.isEmpty(_.get(this, '$store.state.vhr.vehicle', {})),
      vinSummary: _.get(this, '$store.state.vhr.vehicle', { imageClass: '' }),
    }
  },
  methods: {},
}
</script>

<template>
  <div class="cardContainer cardDarker">
    <div class="row">
      <div v-if="!searchSuccess" class="col-12">
        <div :class="[$style.carsSprite]"> </div>
        <p class="mb-0">Get answers to your questions about vehicle history:</p>
        <a v-scroll-to="'#searchVin'" class="p-0 clickLink mb-0" href="#"
          >Search now for vehicle history by VIN or US License Plate »</a
        >
      </div>
      <div v-else class="col-12">
        <div class="row">
          <div class="col-md-8 col-12">
            <div :class="[$style.carsSprite, vinSummary.imageClass]"> </div>
            <p class="mb-0"
              >You searched for this {{ vinSummary.year }}
              {{ vinSummary.make }} {{ vinSummary.model }}: We found
              {{ vinSummary.recordCount }} historical records. Get the full
              report to learn more.</p
            >
          </div>
          <div class="col-md-4 col-12 text-right">
            <a
              v-if="!cart"
              v-scroll-to="'#searchVin'"
              class="left primary-anchor-link linkbold"
              href="#"
              >Search for a different vehicle »</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.carsSprite {
  display: block;
  float: left;
  width: 58px;
  height: 45px;
  margin-right: 15px;
  background: url('@assets/images/cars-small-images.png') no-repeat 0 0;
}
</style>
